import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=5a266725&scoped=true"
import script from "./FolderSelector.vue?vue&type=script&lang=js"
export * from "./FolderSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a266725",
  null
  
)

export default component.exports